module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-Rear_1.e49669a9.jpg";